import React from "react";
import PropTypes from "prop-types";
import ReactInterval from "react-interval";
import Moment from "react-moment";
// import material-ui components
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/styles"
import TablePagination from "@material-ui/core/TablePagination";
// import material-ui icons
import KeyIcon from "@material-ui/icons/VpnKey";
//redux components
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
//import core components
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Table from "components/Table/Table.jsx";

import * as actionCreators from "actions/keys";

import usersStyle from "assets/jss/material-dashboard-react/views/usersStyle"

function mapStateToProps(state) {
    return {
        token: state.auth.token,
        keyData: state.keys.key,
        keyTransactions: state.keys.key_transactions,
        keyTypesIsLoaded: state.keys.key_types.isLoaded,
        keyTypes: state.keys.key_types.data
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

class KeyView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            keyData: {
                id: null,

            },
            keyId: this.props.match.params.id ? this.props.match.params.id : null,
            keyTransactionsData: [],
            timeoutEnabled: false,
            keyTransactionsRowsPerPage: 25,
            keyTransactionsPage: 1,
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        console.log(nextProps);
        this.setState((prevState) => ({
            ...prevState,
            keyData: nextProps.keyData.isLoaded ? nextProps.keyData.data : prevState.keyData,
            keyTransactionsData: nextProps.keyTransactions.isLoaded ? nextProps.keyTransactions.data.map((prop) =>
                [prop.id, prop.machine_id ? `${prop.machine_id}, ${prop.machine_address}` : null, prop.cash_before, prop.cash, prop.water_amount,
                 prop.type === "deposit" ? "Пополнение" :  "Расход", prop.user_name, <Moment format="DD/MM/YYYY HH:mm:ss">{ prop.time }</Moment>])
                : prevState.keyTransactionsData,
        }));
    }

    componentDidMount(){
        this.setState({
            timeoutEnabled: true,
        });
        this.getData();
    }

    componentWillUnmount(){
        this.setState({
            timeoutEnabled: false,
        })
    }

    getData(){
        this.state.keyId && this.props.getKey(this.props.token, this.state.keyId);
        this.state.keyId && this.props.getKeyTransactions(this.props.token, this.state.keyId, this.state.keyTransactionsPage,
            this.state.keyTransactionsRowsPerPage);
    }

    handleKeyTransactionsChangePage(page){
        this.setState({
            keyTransactionsPage: page
        }, this.getData)
    }

    handleKeyTransactionsChangeRowsPerPage(e){
        if (e.target.value !== this.state.keyTransactionsRowsPerPage) {
            this.setState({
                keyTransactionsRowsPerPage: e.target.value
            }, this.getData);
        }
    }


    render(){
        const { classes } = this.props;
        return (
            <div>
                <Card>
                    <CardHeader color="warning" icon>
                        <CardIcon color="warning">
                            <KeyIcon/>
                        </CardIcon>
                        <h3 className={classes.cardTitle}>Ключ #{this.state.keyData.id}</h3>
                    </CardHeader>
                    <CardBody>
                        <Grid container>
                            <GridItem xs={12} md={4}>
                                <h5>Тип ключа: {this.state.keyData.type}</h5>
                                <h5>Баланс: {this.state.keyData.balance} руб.</h5>
                                <h5>Заказов на: {this.state.keyData.orders_sum} руб.</h5>
                            </GridItem>
                            <GridItem xs={12} md={4}>
                                <h5>Хэш ключа: {this.state.keyData.key_hash}</h5>
                                <h5>Владелец: {this.state.keyData.name}</h5>
                                <h5>Телефон: {this.state.keyData.phone}</h5>
                            </GridItem>
                            <GridItem>
                                <h5>Цена по ключу: {this.state.keyData.liter_price} руб.</h5>
                            </GridItem>
                        </Grid>
                        <h3>Операции</h3>
                        <Table
                            tableHead={["ID", "Аппарат", "Изначальный баланс", "Сумма", "Литры", "Тип", "Имя пользователя", "Дата"]}
                            tableData={this.state.keyTransactionsData}
                            tablePagination={(<TablePagination count={this.props.keyTransactions.count || 0}
                                                           onChangePage={(e, page) => this.handleKeyTransactionsChangePage(page + 1)}
                                                           page={this.state.keyTransactionsPage - 1} rowsPerPage={this.state.keyTransactionsRowsPerPage}
                                                           labelDisplayedRows={({from, to, count}) => `${from}-${to} из ${count}`}
                                                           labelRowsPerPage="Строк на страницу:" component="div"
                                                           onChangeRowsPerPage={(e) => this.handleKeyTransactionsChangeRowsPerPage(e)}
                            />)}
                        />
                    </CardBody>
                </Card>

                <ReactInterval timeout={15000} enabled={this.state.timeoutEnabled} callback={() => this.getData()}/>
            </div>
        )
    }
}

KeyView.propTypes = {
    getKey: PropTypes.func,
    getKeyTransactions: PropTypes.func,
    getKeyTypes: PropTypes.func,
    token: PropTypes.string,
    keyTransactions: PropTypes.array,
    keyData: PropTypes.shape({
        isLoading: PropTypes.bool,
        isLoaded: PropTypes.bool,
        data: PropTypes.object,
    }),
    keyTypes: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(usersStyle)(KeyView));


// WEBPACK FOOTER //
// ./src/views/Keys/Key.jsx